import { useTranslation } from 'react-i18next';
import { Flex, Text, Link } from '@chakra-ui/react';

import { GrFacebook } from 'react-icons/gr';
import { BiPhoneCall } from 'react-icons/bi';
import { AiFillInstagram } from 'react-icons/ai';
import { MdLaptopMac } from 'react-icons/md';

import "./Styles/Home.css";


const Socials = (props) => {

    const { t } = useTranslation();
    const { facebook, instagram, phone, website } = props;

    return( 
        <Flex ml={4} direction="column" mb={6} mt={2}>
            <Text fontSize="xl" fontWeight="medium" mt={2} mb={3}>
                {t("contactUs")}
            </Text>
            <Flex justifyContent="center" flexWrap="wrap" width="100%">
                { phone &&
                <Flex direction="column" alignItems="center" mr={4} className="clickable"
                      onClick={ ()=>{ window.location.href = 'tel:'+phone } }>
                    <BiPhoneCall size="44px" color="#065e54"/>
                    <Link href={'tel:'+phone} color="#012e29" isExternal mt={1}>
                        {t("callUs")}
                    </Link>
                </Flex>
                }

                { facebook &&
                <Flex direction="column" alignItems="center" mr={4} className="clickable"
                      onClick={ ()=>{ window.location.href = facebook } }>
                    <GrFacebook size="44px" color="#065e54"/>
                    <Link href={facebook} color="#012e29" isExternal mt={1}>
                        Facebook
                    </Link>
                </Flex>
                }

                { instagram &&
                <Flex direction="column" alignItems="center" mr={4} className="clickable" 
                      onClick={ ()=>{ window.location.href = instagram } }>
                    <AiFillInstagram size="44px" color="#065e54"/>
                    <Link href="#" color="#012e29" isExternal mt={1}>
                        Instagram
                    </Link>
                </Flex>
                }

                { website &&
                <Flex direction="column" alignItems="center" mr={4} className="clickable"
                      onClick={ ()=>{ window.location.href = website } }>
                    <MdLaptopMac size="44px" color="#065e54"/>
                    <Link href={website} color="#012e29" isExternal mt={1}>
                        {t("website")}
                    </Link>
                </Flex>
                }
            </Flex>
        </Flex>
    );
}

export default Socials;